import { Stack } from "@fluentui/react/lib/Stack";

import { IWithThemeProps } from "Components/Generic/Theme/IWithThemeProps";
import { WithTheme } from "Components/Generic/Theme/WithTheme";
import { AddUser } from "./AddUser";
import { User } from "./User/User";
import { useUsernames } from "./UseUsernames";

export const Usernames = WithTheme(({ theme: { spacing } }: IWithThemeProps): JSX.Element => {
  const {
    usernames, username, onEditUser, onAddUser, onRemoveUser
  } = useUsernames();
  return (
    <Stack tokens={{ childrenGap: spacing.m }}>
      <Stack horizontal grow>
        <AddUser username={username} onAddUser={onAddUser} />
      </Stack>
      <Stack tokens={{ childrenGap: spacing.s1 }}>
        {usernames.map((name, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Stack.Item grow={false} key={index}>
            <User username={name} onRemove={onRemoveUser} onEditUser={onEditUser} />
          </Stack.Item>
        ))}
      </Stack>
    </Stack>
  );
});
